import { useEffect, useRef } from 'react';
import { hapticLight } from '@/lib/haptics';

/**
 * Light haptic when a sheet/overlay opens (native only — no-op on web).
 * Call from ResponsiveOverlay when presentation resolves to a mobile sheet.
 */
export function useNativeSheetFeedback(enabled: boolean): void {
  const prevEnabled = useRef(false);

  useEffect(() => {
    if (enabled && !prevEnabled.current) {
      hapticLight();
    }
    prevEnabled.current = enabled;
  }, [enabled]);
}
